import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';
import download from 'downloadjs';
import moment from 'moment';

@inject(HttpClient)
export class DaiatariService {
    constructor(http) {
        this.http = http;
    }

    async getByAssignedProjectId(assignedProjectId) {
        const response = await this.http.fetch(`daiatari/${assignedProjectId}`);
        return await response.json();
    }

    async saveAssignedProjectLinks(assignedProjectId, links) {
        await this.http.fetch(`daiatari/${assignedProjectId}`, { method: 'POST', body: json(links) });
    }

    async filter(loadOptions, filterOptions) {
        const response = await this.http.fetch(`daiatari/report-list/${loadOptions}`, { method: 'POST', body: json(filterOptions) });
        return await response.json();
    }

    async getDaiatariIdsForFilter(filterOptions) {
        const response = await this.http.fetch('daiatari/daiatari-list', { method: 'POST', body: json(filterOptions) });
        return await response.json();
    }

    async generateHTMLReport(reportOptions, daiatariIds) {
        const response = await this.http.fetch('daiatari/report/html', { method: 'POST', body: json({ 
                addChildParts: reportOptions.addChildParts,
                sortBy: reportOptions.sortBy,
                thenBy: reportOptions.thenBy,
                daiatariIds: daiatariIds
            }) 
        });
        return await response.json();
    }

    async generateExcelReport(reportOptions, daiatariIds) {
        const response = await this.http.fetch('daiatari/report/excel', { method: 'POST', body: json({ 
                addChildParts: reportOptions.addChildParts,
                sortBy: reportOptions.sortBy,
                thenBy: reportOptions.thenBy,
                daiatariIds: daiatariIds
            })
        });
        const blob = await response.blob();
        download(blob, `Daiatari - ${moment().format('L')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }

    async generateAPRSteelMasterReport(reportOptions, daiatariIds) {
        const response = await this.http.fetch('daiatari/apr-steel-master-report/excel', { method: 'POST', body: json({ 
                addChildParts: reportOptions.addChildParts,
                sortBy: reportOptions.sortBy,
                thenBy: reportOptions.thenBy,
                daiatariIds: daiatariIds
            })
        });
        const blob = await response.blob();
        download(blob, `APR Steel Master - ${moment().format('L')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }
}